const METRIC_TYPE_SCORE = 1
const METRIC_TYPE_ACCURACY = 2
const METRIC_TYPE_GRADE = 3

const GRADE_LABELS = {
  100: '优',
  80: '良',
  60: '合格',
  40: '须努力',
}

function toNumber(value, fallback = 0) {
  const num = Number(value)
  return Number.isFinite(num) ? num : fallback
}

function formatPercent(value) {
  return `${toNumber(value)}%`
}

function formatScore(value) {
  return `${toNumber(value)}分`
}

function formatGrade(value) {
  const num = toNumber(value)
  return GRADE_LABELS[num] || `${num}分`
}

function getMetricType(report) {
  const metricType = toNumber(report && report.metric_type)
  if ([METRIC_TYPE_SCORE, METRIC_TYPE_ACCURACY, METRIC_TYPE_GRADE].includes(metricType)) {
    return metricType
  }
  return METRIC_TYPE_SCORE
}

function buildScoreDisplay(report) {
  const actualScore = toNumber(report && report.actual_score)
  const totalScore = toNumber(report && report.total_score)
  return {
    type: 'score',
    title: '本次得分',
    mainValue: actualScore,
    suffix: totalScore > 0 ? `/ ${totalScore}分` : '分',
    stats: [
      { label: '正确率', value: formatPercent(report && report.accuracy) },
      { label: '班级平均', value: formatScore(report && (report.class_avg_value || report.class_avg_score)) },
    ],
    showQuestionSummary: true,
  }
}

function buildAccuracyDisplay(report) {
  const actualScore = toNumber(report && report.actual_score)
  const totalScore = toNumber(report && report.total_score)
  const scoreText = totalScore > 0 ? `${actualScore}/${totalScore}分` : formatScore(actualScore)
  const accuracyText = formatPercent(report && report.accuracy)
  return {
    type: 'accuracy',
    title: '本次正确率',
    mainValue: accuracyText,
    suffix: '',
    stats: [
      { label: '本次正确率', value: accuracyText },
      { label: '班级平均', value: formatPercent(report && report.class_avg_value) },
    ],
    subText: `本次得分 ${scoreText}`,
    showQuestionSummary: true,
  }
}

function buildGradeDisplay(report) {
  const metricValue = toNumber(report && report.metric_value)
  return {
    type: 'grade',
    title: '本次评价',
    mainValue: formatGrade(metricValue),
    suffix: '',
    stats: [
      { label: '评价类型', value: '等级评价' },
      { label: '评价结果', value: formatGrade(metricValue) },
    ],
    showQuestionSummary: false,
  }
}

function buildReportDisplay(report) {
  const metricType = getMetricType(report)
  if (metricType === METRIC_TYPE_GRADE) {
    return buildGradeDisplay(report)
  }
  if (metricType === METRIC_TYPE_ACCURACY) {
    return buildAccuracyDisplay(report)
  }
  return buildScoreDisplay(report)
}

module.exports = {
  METRIC_TYPE_SCORE,
  METRIC_TYPE_ACCURACY,
  METRIC_TYPE_GRADE,
  buildReportDisplay,
  formatGrade,
}
